import { SUPPORTED_LOCALES } from '../../utils/numberFormat';

import type { SupportedLocale } from '../../utils/numberFormat';

/**
 * Single source of truth for the locales the app supports.
 *
 * The frontend owns this list: the backend accepts whatever locale the front
 * sends, so there is no backend-provided list to reconcile. Exposed as a
 * selector so consumers depend on a single accessor rather than importing the
 * constant directly (and so the source can change without touching consumers).
 */
export function getSupportedLocales(): readonly SupportedLocale[] {
  return SUPPORTED_LOCALES;
}
